import { render, staticRenderFns } from "./FrzChamberPalletTunnelExternal.vue?vue&type=template&id=73e0075c"
import script from "./FrzChamberPalletTunnelExternal.vue?vue&type=script&lang=js"
export * from "./FrzChamberPalletTunnelExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports